import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  Center,
  Divider,
  HStack,
  Spinner,
  VStack,
  useToast,
} from "@chakra-ui/react";
import GoogleMapReact from "google-map-react";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import LocationList from "../../../components/location/LocationList";
import AddLocation from "../../../components/location/AddLocation";
import Cookies from "js-cookie";
import axios from "../../../axios";

const DEFAULT_CENTER = { lat: 47.91948034963807, lng: 106.91772834219846 };
const DEFAULT_ZOOM = 13;

const UserLocation = () => {
  const [locationList, setLocationList] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const mapRef = useRef(null);
  const mapsRef = useRef(null);
  const clusterRef = useRef(null);
  const infoWindowRef = useRef(null);

  const fetchLocations = useCallback(() => {
    setLoading(true);
    axios
      .get("/v2/user_location/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("accessToken")}`,
        },
      })
      .then((res) => {
        // console.log(res);
        setLocationList(res.data.data || []);
      })
      .catch(() =>
        toast({
          status: "error",
          title: "Алдаа гарлаа",
          duration: 2000,
          isClosable: true,
        })
      )
      .finally(() => setLoading(false));
  }, [toast]);

  useEffect(() => {
    fetchLocations();
  }, [fetchLocations]);

  // Маркер, кластер шинэчлэх
  const updateCluster = useCallback(() => {
    const map = mapRef.current;
    const googleMaps = mapsRef.current;
    const infoWindow = infoWindowRef.current;
    if (!map || !googleMaps) return;

    clusterRef.current?.clearMarkers();

    const markers = locationList.map((loc) => {
      const lat = parseFloat(loc.latitude);
      const lng = parseFloat(loc.longitude);
      const marker = new googleMaps.Marker({
        position: { lat, lng },
        map,
        icon: {
          path: googleMaps.SymbolPath.CIRCLE,
          scale: 8,
          fillColor: "#45A735",
          fillOpacity: 0.8,
          strokeWeight: 2,
          strokeColor: "#FFF",
        },
      });

      marker.addListener("click", async () => {
        infoWindow.close();
        // infoWindow.setContent("<div style='min-width:150px'><Spinner /></div>");
        infoWindow.setContent(`
    <div style="min-width:150px; padding:8px; text-align:center;">
      Уншиж байна...
    </div>
  `);
        infoWindow.open(map, marker);
        try {
          // const res = await axios.get("/v2/user_location/devices", {
          const res = await axios.get("/v2/user_location/info", {
            params: { houseId: loc.houseId },
            headers: { Authorization: `Bearer ${Cookies.get("accessToken")}` },
          });
          console.log("detail --->", res);
          // const devices = res.data.data || [];
          const info =
            res?.data?.data !== null &&
            typeof res?.data?.data === "object" &&
            !Array.isArray(res?.data?.data) &&
            Object.keys(res?.data?.data).length === 4
              ? res?.data?.data
              : null;

          let content = `
            <div style="max-height:200px; overflow-y:auto; min-width:200px; font-size:14px; color:#333;">
              <strong style="font-size:16px; color:#45A735; display:block; margin-bottom:4px;">
                ${loc.houseName}
              </strong>
          `;
          //       devices.forEach((d) => {
          //         if (["switch"].includes(d.deviceType)) {
          //           content += `
          //   <div style="margin:4px 0;">
          //     <span style="font-weight:bold; color:#2c3e50;">
          //       ${d.for}
          //     </span>:
          //     <span style="color:${d.data === "on" ? "#27ae60" : "#c0392b"};">
          //       ${d.data.toUpperCase()}
          //     </span>
          //   </div>
          // `;
          //         } else if (["th"].includes(d.deviceType)) {
          //           content += `
          //   <div style="margin:4px 0;">
          //     <span style="font-weight:bold; color:#2c3e50;">
          //       ${d.for}
          //     </span>:
          //     <span style="color:#e74c3c;">T=${d.data.Temperature}°C</span>,
          //     <span style="color:#3498db;">H=${d.data.Humidity}%</span>
          //   </div>
          // `;
          //         } else {
          //           content += `
          //   <div style="margin:4px 0;">
          //     <span style="font-weight:bold; color:#2c3e50;">
          //       ${d.for}
          //     </span>:
          //     <span style="color:#555;">
          //       ${d.value}
          //     </span>
          //   </div>
          // `;
          //         }
          //       });
          content += `</div>`;
          // infoWindow.setContent(content);

          if (!info)
            return infoWindow.setContent(`<center style="min-width: 200px;" >
          <p style="color: red" >Хоосон байшин!</p>
        </center>`);

          infoWindow.setContent(`
          <div style="display: block; box-sizing: border-box; overflow-y:auto; min-width:240px; font-size:14px; color:#333; padding: 0 10px 10px 10px;">
            <strong style="font-size:16px; color:#45A735; display:block; margin-bottom:4px;">
              ${loc.houseName}
            </strong>
            
            <div style="display: block; box-sizing: border-box; display: flex; width: 100%; justify-content: space-between; margin-top: 12px; " >
              <p style="color: #444444;" >Мэдрэгч төхөөрөмж</p>
              <p style="color: #8654C1; font-weight: 700;"  >${info?.sensors}</p>
            </div>

            <div style="display: block; box-sizing: border-box; display: flex; width: 100%; justify-content: space-between; margin-top: 12px; " >
              <p style="color: #444444;" >Удирдах төхөөрөмж</p>
              <p style="color: #4969C6; font-weight: 700;">${info?.switches}</p>
            </div>

            <div style="display: block; box-sizing: border-box; display: flex; width: 100%; justify-content: space-between; margin-top: 12px;  " >
              <p style="color: #444444;" >Холболтгүй</p>
              <p style="color: rgb(234, 206, 58); font-weight: 700;"  >${info?.offlineDevices}</p>
            </div>

            <div style="display: block; box-sizing: border-box; display: flex; width: 100%; justify-content: space-between; margin-top: 12px;  " >
              <p style="color: #444444;" >Холболттой </p>
              <p style="color: #4CAF50; font-weight: 700;"  >${info?.onlineDevices}</p>
            </div>
          </div>`);
        } catch (err) {
          console.error("detail error --->", err);
          infoWindow.setContent(
            `<div style='min-width:150px;color:red'>Алдаа гарлаа!</div>`
          );
        }
      });

      return marker;
    });

    clusterRef.current = new MarkerClusterer({ map, markers });
  }, [locationList, toast]);

  // Google Maps load
  const handleApiLoaded = ({ map, maps }) => {
    mapRef.current = map;
    mapsRef.current = maps;
    infoWindowRef.current = new maps.InfoWindow();
    updateCluster();
  };

  useEffect(() => {
    if (mapRef.current && mapsRef.current) updateCluster();
  }, [locationList, updateCluster]);

  useEffect(() => {
    if (!mapRef.current) return;
    const listener = mapRef.current.addListener("zoom_changed", updateCluster);
    return () => listener.remove();
  }, [updateCluster]);

  const handleAddLocation = () => fetchLocations();

  const flyTo = (lat, lng) => {
    mapRef.current?.panTo({ lat, lng });
    mapRef.current?.setZoom(15);
  };

  return (
    <HStack w="full" h="80vh" align="stretch" spacing={4}>
      <VStack w="xs" spacing={4}>
        <AddLocation onAdd={handleAddLocation} />
        <Divider />
        <VStack w="full" spacing={2} maxH="72vh" overflowY="auto" px={2} pb={2}>
          {loading ? (
            <Center>
              <Spinner size="sm" color="#45A735" />
            </Center>
          ) : (
            locationList.map((loc) => (
              <LocationList
                key={loc.locationId}
                data={loc}
                onSelectHouse={(lat, lng) => flyTo(lat, lng)}
              />
            ))
          )}
        </VStack>
      </VStack>
      <VStack flex={1} bg="white" rounded="md" shadow="md">
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyC0PZPzftfnrX4eu_O59XKZPYr7xeDHISg" }}
          defaultCenter={DEFAULT_CENTER}
          defaultZoom={DEFAULT_ZOOM}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={handleApiLoaded}
        />
      </VStack>
    </HStack>
  );
};

export default UserLocation;
